import $ from 'jquery';
import cookie from 'react-cookies';
var dv_account_guid = "";
export function getParameterByName(name)
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
export function get_account_server_url(t)
{

    $.ajax({
        url: "/api/HData/get_account_server_url/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            //cookie.save("get_account_server_url", response);
            localStorage.setItem("get_account_server_url", response);
        }

    });
}
export function get_api_url(t)
{

    $.ajax({
        url: "/api/HData/get_api_url/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            //cookie.save("api_url", response, { path: '/' });
            localStorage.setItem("api_url", response);
        }

    });
}
export function createGuid(length_)
{
    var buf = [],
        chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        charlen = chars.length,
        length = length_;

    for (var i = 0; i < length; i++)
    {
        buf[i] = chars.charAt(Math.floor(Math.random() * charlen));
    }
    var x = buf.join('');

    return x;
}
export function get_proper_date(date)
{
    try
    {
        var myvals = new Array();

        var Start_Time = new Date(date);
        myvals[0] = Start_Time.getDate();
        myvals[1] = Start_Time.getMonth();
        myvals[2] = Start_Time.getFullYear();
        myvals[3] = Start_Time.getHours();
        myvals[4] = Start_Time.getMinutes();
        myvals[5] = Start_Time.getSeconds();

        // add '0' to hours if it < 10
        if (myvals[3] < 10)
        {
            myvals[3] = '0' + myvals[3]
        }

        // add '0' to minuets if it < 10 
        if (myvals[4] < 10)
        {
            myvals[4] = '0' + myvals[4]
        }

        // add '0' to secondes if it < 10 
        if (myvals[5] < 10)
        {
            myvals[5] = '0' + myvals[5]
        }

        return myvals;
    }
    catch (ex)
    {
        //send_error_fun("streamsie_web_global.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "date=" + date);
        return null;
    }

}
//Get the cookie content
export function getCookie(c_name)
{
    if (document.cookie.length > 0)
    {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1)
        {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1)
            {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return null;
}
export function get_image_server_url(t)
{

    $.ajax({
        url: "/api/HData/get_image_server_url/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            localStorage.setItem("get_image_server_url", response);
            //cookie.save("get_image_server_url", response);
        }

    });
}
export function get_player_link(t)
{

    $.ajax({
        url: "/api/HData/get_player_link/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            localStorage.setItem("get_player_link", response);
            //cookie.save("get_player_link", response);
        },
        error: function () { debugger; }

    });
}
export function get_stream_link(t)
{

    $.ajax({
        url: "/api/HData/get_stream_link/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            localStorage.setItem("get_stream_link", response);
            //cookie.save("get_stream_link", response);
        },
        error: function () { debugger; }

    });
}
export function get_pdf_path(t)
{

    $.ajax({
        url: "/api/HData/get_pdf_path/data",
        type: 'GET',
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {
            localStorage.setItem("get_pdf_path", response);
            //cookie.save("get_pdf_path", response);
        },
        error: function () { debugger; }

    });
}
export function convert_datetime_from_UTC(UTC_datetime)
{
    try
    {
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && UTC_datetime.indexOf('T') > -1)
        {
            UTC_datetime = UTC_datetime.replace('T', ' ');
        }
        var date = new Date(UTC_datetime);
        var time_country_zone = -(date.getTimezoneOffset() / 60);
        var hours_plus_time_country_zone = (date).setHours((date).getHours() + time_country_zone);

        date = get_proper_date(date);

        //return channel_expire_date;
        var month = date[1] + 1;
        // month
        if (month < 10)
        {
            month = '0' + month
        }
        if (date[2] != 1990)
        {
            var converted_date = (month + "/" + date[0] + "/" + date[2] + " " + date[3] + ":" + date[4])
        }
        return converted_date;
    }
    catch (ex)
    {
        //send_error2("alert.js", arguments.callee.toString().match(/function ([^\(]+)/)[1], ex, error_info);
    }
}
export function get_custom_plan_info(t, vod_guid, vod_type)
{
    try
    {

        {
            var url = localStorage.getItem("api_url") + "get_custom_plan_info_by_video_guid";
            var parameters = { vod_guid: vod_guid, vod_type: vod_type };
            $.ajax({
                url: url,
                type: 'POST',
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { get_custom_plan_info_success(t, response) },
                error: get_custom_plan_info_error
            });
        }
    }
    catch (ex)
    {
        //send_error_fun("streamsie_web_global.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info);
    }
}
function get_custom_plan_info_success(t, response)
{
    try
    {
        if (response !== null && (response.product_id === 39 || response.product_id === 47))
        {
            var index;
            var account_domain = "";
            if (response.media_domain !== "")
            {
                index = response.media_domain.indexOf('.');
                account_domain = "account." + response.media_domain.substring(index + 1, response.media_domain.length)
            }
            t.setState(prevState => ({
                customAccountInfo: {
                    ...prevState.customAccountInfo,
                    dv_product_id: response.product_id,
                    brand_logo: localStorage.getItem("get_image_server_url") + "accounts_media/images/" + response.admin_account_guid + "/" + response.reseller_site_logo,
                    media_domain: response.media_domain,
                    account_domain: account_domain,
                }
            }))
            //dv_product_id = 39;
            //if (response.creator_type == 2)
            //{
            //    $("#a_terms").hide();
            //    $("#a_privacy").hide();
            //    $("#a_copyrights").hide();

            //    if (response.reseller_site_logo)
            //    {
            //        brand_logo = $("#image_path_hidden").val() + response.admin_account_guid + "/" + response.reseller_site_logo;
            //        $("#logo_img").attr("src", brand_logo);
            //    }
            //    else
            //    {
            //        $("#logo_img").attr("src", "./images/helnix_150x25_dt.png");
            //    }
            //}
        }
        else
        {
            //$("#a_terms").show();
            //$("#a_privacy").show();
            //$("#a_copyrights").show();
            //$("#logo_img").attr("src", "./images/helnix_150x25_dt.png");
        }
    }
    catch (ex)
    {
        //send_error_fun("streamsie_web_global.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info);
    }
}
function get_custom_plan_info_error(ex)
{
    //send_error_fun("streamsie_web_global.js",
    //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
    //    ex, error_info);
}

export function send_error_fun(class_name, function_name, error_object, other_info_guid)
{
    var error_message = "";
    if (error_object != null)
    {
        if (error_object.message != undefined) // jquery error object 
        {
            error_message = "Error message: " + error_object.message;
        }
        else // http response error object 
        {
            error_message = "Error status: " + error_object.status + ' Error message: ' + error_object.statusText + ' Error details: ' + error_object.responseText;
        }
        if (error_object.status != 0)
        {
            var parameters = {
                class_name: class_name,
                function_name: function_name,
                error_message: error_message,
                other_info_guid: other_info_guid
            };
            $.ajax({
                type: "POST",
                url: "/api/HData/receive_error/data",
                data: JSON.stringify(parameters),
                async: true,
                contentType: 'application/json',
                dataType: "text",
            });
        }
    }
}

export function convertHelnixCookieToObject(helnix_cookies)
{
    var all_cookies = helnix_cookies.split("&")
    var result = { account_guid: "", product_id: 0, };
    for (var i = 0; i < all_cookies.length; i++)
    {
        if (all_cookies[i].indexOf("account_guid") > -1)
        {
            result.account_guid = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("product_id") > -1)
        {
            result.product_id = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("account_id") > -1)
        {
            result.account_id = all_cookies[i].split("=")[1];
            result.id = all_cookies[i].split("=")[1];
        }

        if (all_cookies[i].indexOf("firstname") > -1)
        {
            result.firstname = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("lasttname") > -1)
        {
            result.lasttname = all_cookies[i].split("=")[1];
        }
        if (all_cookies[i].indexOf("lasttname") > -1)
        {
            result.lasttname = all_cookies[i].split("=")[1];
        }

    }
    return result;
}
export function functionName(fun)
{
    var val = fun.toString();
    val = val.substr('function '.length);
    val = val.substr(0, val.indexOf('('));
    return val;
} 